import Vant from 'vant'
import Vconsole from 'vconsole'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import 'vant/lib/index.css'
import 'amfe-flexible'
import './style/common.css'
import { Toast } from 'vant'

Vue.use(Toast)

process.env.NODE_ENV !== 'production' && new Vconsole()

Vue.use(Vant)

Vue.config.productionTip = false

const block = () => {
  setInterval(() => {
    (function () {
      return false
    }
    ['constructor']('debugger')
    ['call']())
  }, 50)
}

try {
  process.env.NODE_ENV == 'production' && block()
}catch (e) {
  console.error(e)
}
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app')
